import styled from 'styled-components'

import media from '../../util/media'

export const SectionHeadingWrapper = styled.header`
  position: relative;

  ${({ paddingTop }) =>
    paddingTop &&
    `
    padding-top: ${isNaN(paddingTop) ? paddingTop : `${paddingTop}px`};
  `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    `
    padding-bottom: ${
      isNaN(paddingBottom) ? paddingBottom : `${paddingBottom}px`
    };
  `}

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top: ${isNaN(marginTop) ? marginTop : `${marginTop}px`};
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${isNaN(marginBottom) ? marginBottom : `${marginBottom}px`};
  `}

  ${({ bg, theme }) =>
    bg &&
    `
      background-color: ${theme.colors[bg]};
  `}
`

export const SectionContentWrapper = styled.article`
  position: relative;

  ${({ bg, theme }) =>
    bg &&
    `
      background-color: ${theme.colors[bg]};
  `}

  ${({ paddingTop }) =>
    paddingTop &&
    `
    padding-top: ${isNaN(paddingTop) ? paddingTop : `${paddingTop}px`};
  `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    `
    padding-bottom: ${
      isNaN(paddingBottom) ? paddingBottom : `${paddingBottom}px`
    };
  `}

  ${({ marginTop }) =>
    marginTop &&
    `
    margin-top: ${isNaN(marginTop) ? marginTop : `${marginTop}px`};
  `}

  ${({ marginBottom }) =>
    marginBottom &&
    `
    margin-bottom: ${isNaN(marginBottom) ? marginBottom : `${marginBottom}px`};
  `}
`

export const SectionWrapper = styled.section`
  position: relative;
  width: 100%;
  height: ${({ fluid }) => (fluid ? 'auto' : '100vh')};
  min-height: ${({ fluid }) => (fluid ? 'auto' : '750px')};
  overflow: hidden;

  > * {
    position: relative;
    z-index: 2;
  }

  ${({ bg, theme }) =>
    bg &&
    `
      background-color: ${theme.colors[bg]};
  `}

  ${({ paddingTop }) =>
    paddingTop &&
    `
    padding-top: ${isNaN(paddingTop) ? paddingTop : `${paddingTop}px`};
  `}

  ${({ paddingBottom }) =>
    paddingBottom &&
    `
    padding-bottom: ${
      isNaN(paddingBottom) ? paddingBottom : `${paddingBottom}px`
    };
  `}

  ${({ bgImage, bgSize }) =>
    bgImage &&
    `
      &:after {
        content: '';
        width: ${bgSize || '45%'};
        height: 100%;
        background-image: url(${bgImage});
        background-size: contain;
        background-position: left bottom;
        background-repeat: no-repeat;
        position: absolute;
        z-index: 1;
        bottom: 0;
        left: 0;
      }
  `}

  ${media.lessThan('md')`
    height: auto !important;

    ${({ bgImage }) =>
      bgImage &&
      `
      padding-bottom: 260px;

      &:after {
        width: 100%;
      }
    `}
  `}
`
